import React, { useEffect, useState } from 'react';
import { dataForVacationApplicationSupervisorTable, sortingDate } from 'shared/helpers/utils';
import { Badge, notification, Popconfirm, Skeleton } from 'antd';
import { viewerModel } from 'entities/viewer';
import { useAppSelector } from 'app/store';
import { RequestsSearch } from 'shared/types/types';
import { usePullSort } from 'shared/hooks';
import { RequestStatusType, SortCondition } from 'shared/enums';
import { SearchKeysNews } from 'shared/enums/news';
import { getCurrentDivision } from 'entities/divisions/model';
import { TableVacationApplication } from 'features/tables/supervisor/TableVacationApplication';
import { vacationApplicationSupervisorApi } from 'app/services/edpApiV1/supervisor/vacationApplication';
import { TabKeys } from 'features/divisions';
import { getVacationApplicationSupervisor } from 'entities/supervisor/vacationApplication';
import { ColumnsType } from 'antd/lib/table';
import { DayOffsStatusTypesMap } from 'shared/types/dayoff.types';
import { VacationModal } from 'features/vacations/vacationModal';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import style from './index.module.scss';

export type TPreparedVacationSupervisorInfoData = {
  key: number;
  id: number;
  fio: string;
  vacationType: string;
  type: string;
  startedAt: string;
  endedAt: string;
  amountDays: number;
  status: {
    name: string;
    type: RequestStatusType;
  };
};

export const VacationArchive = () => {
  const [page, setCurrentPage] = useState<number>(1);
  const [size, setCurrentSize] = useState<number>(10);
  const [openModal, setOpenModal] = useState(false);
  const [sortInfo, sortTrigger] = usePullSort();
  const sortOption = sortInfo.value && sortInfo.value === SortCondition.ASCEND ? SortCondition.ASC : SortCondition.DESC;
  const [search, setSearch] = useState<RequestsSearch>({ byId: undefined, fio: undefined });
  const [requestToReject, setRequestToReject] = useState<number>(0);

  const { currentOption } = useAppSelector(getCurrentDivision);
  const profile = useAppSelector(viewerModel.me.selectors.selectViewerProfile);

  const [getVacationsDeputy] = vacationApplicationSupervisorApi.useLazyVacationsDeputyQuery();
  const [getVacationsActing] = vacationApplicationSupervisorApi.useLazyVacationsActingQuery();
  const [getVacationsSupervisor] = vacationApplicationSupervisorApi.useLazyVacationsSupervisorQuery();

  const { data, pagination, loading, success, error } = useAppSelector(getVacationApplicationSupervisor);

  const refetch = () => {
    if (!currentOption) {
      return;
    }
    try {
      switch (currentOption.type) {
        case TabKeys.ACTING:
          getVacationsActing({ isArchive: true, page, size, divisionId: currentOption.value, ...search });
          break;
        case TabKeys.DEPUTY:
          getVacationsDeputy({ isArchive: true, page, size, divisionId: currentOption.value, ...search });
          break;
        case TabKeys.SUPERVISOR:
          getVacationsSupervisor({ isArchive: true, page, size, ...search });
          break;
      }
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    }
  };

  useEffect(() => {
    refetch();
  }, [currentOption, search, page, size]);

  const columns: ColumnsType<TPreparedVacationSupervisorInfoData> = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },

    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Вид отпуска',
      dataIndex: 'vacationType',
      key: 'vacationType',
    },

    {
      title: 'Тип заявления',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Дата начала',
      dataIndex: 'startedAt',
      key: 'startedAt',
      sorter: (a, b) => sortingDate(a.startedAt, b.startedAt),
    },
    {
      title: 'Дата окончания',
      dataIndex: 'endedAt',
      key: 'endedAt',
      sorter: (a, b) => sortingDate(a.endedAt, b.endedAt),
    },
    {
      title: 'Дни',
      dataIndex: 'amountDays',
      key: 'amountDays',
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (status: { type?: RequestStatusType; name: string }) => (
        <span>
          <Badge className={style.badge} status={status.type ? DayOffsStatusTypesMap[status.type] : 'processing'} />
          {status?.name}
        </span>
      ),
    },
  ];

  const onSearch = (data: string, key: SearchKeysNews) => {
    if (key === SearchKeysNews.SEARCH_ID) {
      setSearch({ fio: undefined, byId: data ? data : undefined });
    } else if (key === SearchKeysNews.SEARCH_NAME) {
      setSearch({ byId: undefined, fio: data ? data : undefined });
    } else {
      setSearch({ [key]: data ? data : undefined });
    }
  };

  const onRowClick = (data: any) => {};

  return (
    <>
      {data && columns && (
        <TableVacationApplication
          dataSource={dataForVacationApplicationSupervisorTable(data || [])}
          columns={columns}
          currentPage={page}
          setCurrentPage={setCurrentPage}
          currentSize={size}
          setCurrentSize={setCurrentSize}
          total={pagination?.total}
          onSearch={onSearch}
          onRowClick={onRowClick}
          loading={loading}
        />
      )}
    </>
  );
};
